export default __webpack_public_path__ + "static/media/2.14845819.jpg";